var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem, Select } from "@mui/material";
import { DataTypeOperator } from "../../../models/audience/filter.model";
export var FilterBooleanInput = function (_a) {
    var operator = _a.operator, filterRow = _a.filterRow, setFilterRow = _a.setFilterRow;
    var content = null;
    switch (operator) {
        case DataTypeOperator.EQUAL:
            content = (_jsx(Select, __assign({ variant: 'outlined', value: filterRow.textValues, onChange: function (e) {
                    var value = e.target.value;
                    setFilterRow(__assign(__assign({}, filterRow), { textValues: [value] }));
                }, size: 'small' }, { children: ['true', 'false'].map(function (slot, index) {
                    return (_jsx(MenuItem, __assign({ value: slot }, { children: slot ? ('Yes/True') : ('No/False') }), slot));
                }) })));
            break;
    }
    return content;
};
